import React from 'react'
import Table, { TableApiParamsType } from '../../components/Table'
import { axiosAPI } from '../../../engine/config/axios'

export default function Tag() {
  const gridParams = {
    grids: [{ name: 'tags' }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
    filters: loadOptions?.filter,
    sort: loadOptions?.sort,
    ...pageParams
  });

  return <Table
    apiParams={apiParams}
    gridParams={gridParams}
    api={axiosAPI.tags.table}
    gridName="tags"
    sortingMode="multiple"
  />
}
